module.exports = __webpack_public_path__ + "img/图层 23.1347be99.png";